// Purpose: Sanitize Legacy LGV rich-text HTML before React inserts it into the
// document.
// Features: Preserves normal Quill formatting while removing scripts, embedded
// documents, event handlers, and inline style payloads.
// Dependencies: DOMPurify. Important behavior: every value is coerced to a
// string and sanitized at the final rendering boundary.

import DOMPurify from "dompurify";

export const sanitizeHtml = (value) => DOMPurify.sanitize(
  String(value || ""),
  {
    USE_PROFILES: {html: true},
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed"],
    FORBID_ATTR: ["style"],
  }
);
